<template>
  <div class="TransferStatuses__Widget" v-if="ready && filteredTransfers.length">
    <div class="widget-actions" v-if="allowRePortImport">
      <b-button :loading="isUpdatingDocuments" type="is-primary" size="is-small"
        @click="updateTransferDocuments">
        עדכן מסמכי הסבה
      </b-button>
    </div>
    <b-collapse v-for="(transfer, index) in filteredTransfers" :key="index" class="content" :open="false">
      <template #trigger="props">
        <div class="transfer-header">
          <div class="transfer-info">
            <div><b>מ:</b> {{ transfer.From }}</div>
            <div><b>ל:</b> {{ transfer.To }}</div>
          </div>
          <div class="header-actions">
            <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'" />
            <b-button :loading="isLoading" @click.stop="preview(transfer)">
              <b-icon icon="download-circle" />
            </b-button>
          </div>
        </div>
      </template>
      <div v-for="(event, idx) in transfer.Events" :key="idx" class="status-event">
        <div>
          <b>{{ event.Status }}</b>
        </div>
        <div class="updated-by">
          <span class="datetime">{{ event.Date | date }}</span>
        </div>
        <div class="reference" v-if="event.Reference">{{ event.Reference }}</div>
        <div v-if="event.ScannedPdfUrl">
          <a href="#" @click.prevent="downloadFile(event.ScannedPdfUrl)" title="מסמך סרוק מהמייל">
            <b-icon icon="file-document-outline" />
          </a>
        </div>
      </div>
    </b-collapse>
  </div>
  <h1 v-else>אין נתוני הסבה</h1>
</template>

<script>
import FilesService from "@/services/FilesService";
import VueIframeWritable from "@/components/VueIframeWritable.vue";
import LeasingCompaniesService from "@/services/LeasingCompaniesService";
import ReportService from "@/services/ReportService";
import {
  ToastProgrammatic as Toast,
  DialogProgrammatic as Dialog,
} from "buefy";
import moment from 'moment';
import printer from "../../plugins/printer";

export default {
  name: 'TransferStatusesCompanyClientWidget',
  props: ['ready', 'namespace', 'field'],
  data() {
    return {
      isLoading: false,
      isUpdatingDocuments: false,
    };
  },
  computed: {
    filteredTransfers() {
      return this.$store.state.report.ClientTransfers || [];
    },
    allowRePortImport() {
      return this.$store.state.profile.AllowRePortImport;
    },
  },
  filters: {
    date(value) {
      const date = moment(value, 'YYYY-MM-DDThh:mm');
      return date.format('DD/MM/YYYY HH:mm');
    },
  },
  methods: {
    init() {
      this.$emit('onReady');
    },
    updateTransferDocuments() {
      Dialog.confirm({
        message: "האם ברצונך לבטל את ההסבה הנוכחית ולעדכן את מסמכי ההסבה מחדש?",
        confirmText: "כן",
        cancelText: "לא",
        onConfirm: () => {
          this.isUpdatingDocuments = true;
          ReportService.updateTransferDocuments(this.$store.state.report.Id)
            .then((r) => {
              const message = r.data.Success
                ? `הפעולה בוצעה בהצלחה, המערכת ניגשת לקלוט מחדש את המסמכים המעודכנים,
                  <br />הדוח יופיע בטאב דוחות פתוחים בסטטוס הסבה חדש.`
                : `
                  <div>הפעולה נכשלה!</div>
                  <div>${r.data.Message || ""}</div>
                `;
              Dialog.confirm({
                message: `<div style="max-height:300px">${message}</div>`,
                confirmText: 'סגור',
                canCancel: false,
              });
              this.$store.dispatch('report/loadReport', { id: this.$store.state.report.Id });
            })
            .catch(() => {
              Toast.open({
                type: "is-danger",
                message: "קרתה תקלה, הפעולה לא התבצעה!",
                duration: 8000,
              });
            })
            .finally(() => {
              this.isUpdatingDocuments = false;
            });
        },
      });
    },
    preview(transfer) {
      const loadingComponent = this.$buefy.loading.open();
      const scrollPosition = document.body.querySelector('.table-wrapper')?.scrollTop;
      LeasingCompaniesService.printTransfersByBatchItemId([transfer.Id])
        .then((r) => {
          this.$iframe.open({
            html: r.data?.Html,
            component: VueIframeWritable,
            onSave: async ({ close, loading }) => {
              loading(true);
              this.downloadFile(transfer.TransferPdfUrl).finally(() => {
                loading(false);
                close();
              });
            },
            onPrint: async ({ loading }) => {
              loading(true);
              printer.printHtml(r.data.Html, scrollPosition);
              loading(false);
            },
          });
        })
        .finally(() => {
          loadingComponent.close();
        });
    },
    downloadFile(url) {
      this.isLoading = true;
      return FilesService.getTransferPdf(url, {
      })
        .then((r) => {
          FilesService.saveResponseFile(r, "הסבה.pdf");
        })
        .catch(() => {
          Toast.open({
            type: "is-danger",
            message: "המערכת נתקלה בבעיה! יש לנסות שוב או לפנות לתמיכה הטכנית.",
            position: "is-bottom",
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    ready(newValue) {
      if (newValue) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.TransferStatuses__Widget {
  width: 100%;

  .widget-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }

  .content {
    border-radius: 4px;
    margin: 6px 0;
    border: 1px solid #e0e0e0;

    /deep/ .collapse-content {
      display: flex;
      flex-direction: column;
      padding: 0 8px 6px;
    }

    .status-event {
      padding: 4px 12px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 15px;
        right: -8px;
        width: 15px;
        height: 1px;
        background-color: #c0c0c0;
      }
    }

    span {
      padding-left: 5px;
    }

    .updated-by {
      color: #b0b0b0;
      font-size: 0.85em;

      .datetime {
        color: #888;
      }
    }

    .reference {
      padding-left: 5px;
      margin: 5px 0px;
    }
  }

  .transfer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #e8eef5;
    padding: 6px 8px;
    border-radius: 4px;
    cursor: default;
    transition: background-color 0.2s;

    &:hover {
      background-color: #dce4ed;
    }
  }

  .transfer-info {
    display: flex;
    flex-direction: column;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  button {
    border: none;
    background: transparent;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

}
</style>
